import { Helmet } from 'react-helmet-async'

function MetaTag(props) {
  const { title, description, imgSrc, url } = props

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content="더룸" />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imgSrc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
    </Helmet>
  )
}

export default MetaTag